import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<button class="icon-btn svelte-b0xf1dt7hqzm"><!></button>`);

function IconButton($$anchor, $$props) {
	let size = $.prop($$props, 'size', 3, 44);
	var button = root();
	var node = $.child(button);

	$.snippet(node, () => $$props.children);
	$.reset(button);

	$.template_effect(() => {
		$.set_style(button, `width:${size() ?? ''}px;height:${size() ?? ''}px`);
		$.set_attribute(button, 'aria-label', $$props.label);
	});

	$.delegated('click', button, function (...$$args) {
		$$props.onclick?.apply(this, $$args);
	});

	$.append($$anchor, button);
}

if (import.meta.hot) {
	IconButton = $.hmr(IconButton);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-b0xf1dt7hqzm');
		IconButton[$.HMR].update(module.default);
	});
}

export default IconButton;

$.delegate(['click']);
import "bun-svelte:IconButton.svelte-3roywaxdk870r-style.css";